import AdvancedSelectBox from "components/AdvancedSelectBox";
import styles from "./styles.module.scss";

function DepartmentSelect({ teams, setSelected, selected }) {
  const options = teams.map((item) => ({
    title: item.title,
    value: item.id,
    subTitle: item.channelUrl,
  }));

  options.unshift({
    title: "همه",
    value: "",
  });

  const handleChangeDepartment = (value) => setSelected(value);

  return (
    <AdvancedSelectBox
      value={selected}
      onChange={handleChangeDepartment}
      title="انتخاب دپارتمان"
      options={options}
      classNames={{
        head: styles.selectbox_head,
        list: styles.selectbox_list,
      }}
    />
  );
}

export default DepartmentSelect;
